import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { STEPS_ROUTE } from '../shared/constants/routes';
import { StepsComponent } from './steps/steps.component';
import { AuthGuard } from '../guards/auth.guard';

const routes: Routes = [
  {
    path: STEPS_ROUTE,
    component: StepsComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class StepsRoutingModule {}
